var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.exportExcel}},[_vm._t("default",function(){return [_vm._v("导出数据")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }